import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { formatChatTimestamp } from '../../utils/helpers';
import asviAssistantIcon from '../../assets/chatbot/asvi-assistant.jpg';
import './chatbot.css';

const ChatMessage = ({ message }) => {
  const { t } = useTranslation();
  const isUser = message.sender === 'user';

  return (
    <div className={`chat-message ${isUser ? 'user-message' : 'bot-message'}`}>
      <div className="message-avatar">
        {isUser ? (
          '👤'
        ) : (
          <img src={asviAssistantIcon} alt="" className="message-avatar-img" />
        )}
      </div>
      <div className="message-content-wrapper">
        <div className="message-header-info">
          <span className="message-sender">{isUser ? t('chatbot.you') : t('chatbot.name')}</span>
          {message.timestamp && (
            <span className="message-time">
              {formatChatTimestamp(message.timestamp)}
            </span>
          )}
        </div>
        <div className="message-bubble">
          {isUser ? (
            <p className="user-text">{message.text}</p>
          ) : (
            <div className="markdown-body">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {message.text}
              </ReactMarkdown>
            </div>
          )}
        </div>
        {message.source && (
          <div className="message-source">
            <small>Source: {message.source}</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
